'use client';
import React from 'react';

import { Typography } from '@mui/material';

import EditInAdminButton from '../EditInAdminButton';
import { log } from '@/utils/logger';

export type HeadingSizeType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

interface HeadingWithHeadingProp extends HeadingPropsBase {
  heading: string;
  children?: never;
}

interface HeadingWithChildrenProp extends HeadingPropsBase {
  heading?: never;
  children: React.ReactNode;
}

type HeadingProps = HeadingWithHeadingProp | HeadingWithChildrenProp;

interface HeadingPropsBase {
  headingSize?: HeadingSizeType;
  headingComponent?: HeadingSizeType;
  sx?: object;
  item?: RestDataPayload;
}

/**
 * @todo refactor headingSize > size, headingComponent > component
 */
export default function Heading({
  heading,
  children,
  headingSize = 'h1',
  headingComponent = 'h1',
  sx = {},
  item = null,
}: HeadingProps) {
  const [isHovered, setIsHovered] = React.useState(false);

  if (!heading && !children) {
    log.warning('No heading or children provided to Heading');
    return null;
  }

  return (
    <Typography
      variant={headingSize}
      component={headingComponent}
      sx={{
        marginTop: '3.75rem',
        marginBottom: '1.25rem',
        position: 'relative',
        ...sx,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <EditInAdminButton item={item} visible={isHovered} />
      {heading || children}
    </Typography>
  );
}
